import { Component, OnInit, Input, Optional, Self, ElementRef } from '@angular/core';
import { MatLegacyFormFieldControl as MatFormFieldControl } from '@angular/material/legacy-form-field';
import { ControlValueAccessor, UntypedFormGroup, NgControl, UntypedFormBuilder } from '@angular/forms';
import { Subject } from 'rxjs';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { NumberCoordinate } from '../../lottoloca-commom/lottery-modex';
import { FocusMonitor } from '@angular/cdk/a11y';
import { List } from 'linqts';


export class CoordinateNumber {
  public key: number;
  public point: any;
}

@Component({
  selector: 'number-coordinates',
  templateUrl: './number-coordinates.component.html',
  styleUrls: ['./number-coordinates.component.css'],
  providers: [
    
    { provide: MatFormFieldControl, useExisting: NumberCoordinatesComponent },
 
  ],
  host: {
    '[class.floating]': 'shouldLabelFloat',
    '[id]': 'id',
    '[attr.aria-describedby]': 'describedBy',
  }
 })
export class NumberCoordinatesComponent implements MatFormFieldControl<CoordinateNumber[]>, ControlValueAccessor, OnInit {




  static nextId = 0;
  parts: UntypedFormGroup;
  stateChanges = new Subject<void>();
  focused = false;
  //ngControl = null;
  errorState = false;
  controlType = 'number-coordinates';
  id = `number-coordinates-${NumberCoordinatesComponent.nextId++}`;
  describedBy = '';
  _isReady: boolean = false;

  private onChange: (value: CoordinateNumber[]) => void;
  _value: NumberCoordinate[];


  public changeDate() {

    this.onChange(this.value);
  }

  writeValue(obj: CoordinateNumber[]): void {


    this.value = obj;
  }
  registerOnChange(onChange: (value: CoordinateNumber[]) => void): void {
    this.onChange = onChange;
  }
  registerOnTouched(fn: any): void {
    //throw new Error("Method not implemented.");
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;

    if (isDisabled) {
      this.parts.get("textValue").disable();
    }
    else {
      this.parts.get("textValue").enable();
    }
  }


  get empty() {
    const { value: { textValue } } = this.parts;

    return !textValue;
  }

  get shouldLabelFloat() { return this.focused || !this.empty; }

  @Input()
  get placeholder(): string { return this._placeholder; }
  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }
  private _placeholder: string;

  @Input()
  get required(): boolean { return this._required; }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _required = false;

  @Input()
  get disabled(): boolean { return this._disabled; }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _disabled = false;

  @Input()
  get value(): NumberCoordinate[] | null {

    // const { value: { textValue } } = this.parts

    // // let strDate:string = textValue;

    // let texts = textValue.split(" ");

    // let numbers: Array<number> = new Array();

    // texts.forEach(x => {
    //   if(x!=null)
    //   {
    //       numbers.push(parseInt(x));

    //   }

    // });


    return this._value;

  }

  set value(value: NumberCoordinate[] | null) {

    if (value == null) {
      this._value = [];
    }
    else {

      this._value = value;
    }


    this.stateChanges.next();
  }

  constructor(@Optional() @Self() public ngControl: NgControl, fb: UntypedFormBuilder, private fm: FocusMonitor, private elRef: ElementRef<HTMLElement>) {

    // Setting the value accessor directly (instead of using
    // the providers) to avoid running into a circular import.
    if (this.ngControl != null) { this.ngControl.valueAccessor = this; }

    this.parts = fb.group({
      textValue: ''
    });

    fm.monitor(elRef.nativeElement, true).subscribe(origin => {
      this.focused = !!origin;
      this.stateChanges.next();
    });
  }

  ngOnDestroy() {
    this.stateChanges.complete();
    this.fm.stopMonitoring(this.elRef.nativeElement);
  }

  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(event: MouseEvent) {
    if ((event.target as Element).tagName.toLowerCase() != 'input') {
      this.elRef.nativeElement.querySelector('input')!.focus();
    }
  }



  //******************************* */
  @Input() cols: number;

  @Input() rows: number;

  public _indexes: any[] = [];



  ngOnInit() {

    let indexes = this.cols * this.rows;

    let index: number = 0;

    let i: number = 0;
    let j: number = 0;


    let promise = new Promise<boolean>((resolve) => {

      let list: List<CoordinateNumber>;

      if (this.value != null) {
        list = new List(this.value);

      }


      for (i = 0; i < this.rows; i++) {
        for (j = 0; j < this.cols; j++) {

          let name = "(" + i + ";" + j + ")";

          // if (list != null && list.Any(x => x.point.X == j && x.point.Y == i)) {

          //   let element = list.First(x => x.point.X == j && x.point.Y == i)
          //   this._indexes.push({ value: element.key, name: name, X: j, Y: i });
          // }
          // else {
          this._indexes.push({ value: '', name: name, X: j, Y: i });
          //   }

        }
      }

      resolve(true)
      this._isReady = true;
    });

    promise.then((result => {
  
      this.updateGui();

    }
    ));



  }
  public updateGui(): any {
    let list: List<CoordinateNumber>;

    if (this._value != null) {
      list = new List(this._value);

      this._indexes.forEach(index => {
        let coordinateElement = list.FirstOrDefault(x => x.point.X == index.X && x.point.Y == index.Y);
        if (coordinateElement != null) {
          index.value = coordinateElement.key;
        }

      });
    }
  }

  public showValue() {
    console.log(this._value);
  }

  public onChangeCoordinate(X: number, Y: number, value: any) {


    let list: List<CoordinateNumber>;

    if (this._value != null) {
      list = new List(this._value);


      let coordinateElement = list.FirstOrDefault(x => x.point.X == X && x.point.Y == Y);

      if (value == null || value == '') {

        if (coordinateElement != null) {

          list.Remove(coordinateElement);
        }

      }
      else {

        if (coordinateElement != null) {

          coordinateElement.key = parseInt(value);
        }
        else {

          let newElement: CoordinateNumber = new CoordinateNumber();

          newElement.key = parseInt(value);
          newElement.point = { X: X, Y: Y };

          list.Add(newElement);
        }
      }


      this._value = list.ToArray();


      this.onChange(this.value)

    }


  }

  // public updateModel(): any {
  //   let list: List<CoordinateNumber>;

  //   if (this._value != null) {
  //     list = new List(this._value);

  //     this._indexes.forEach(index => {
  //       let coordinateElement = list.FirstOrDefault(x => x.point.X == index.X && x.point.Y == index.Y);
  //       if (coordinateElement != null) {
  //         index.value = coordinateElement.key;
  //       }

  //     });
  //   }
  // }

}
